module.exports = __webpack_public_path__ + "static/media/facebook.953a7abd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/facebook.svg
// module id = 220
// module chunks = 2